/**
 * Google Tag Manager container ID (same value shown in the GTM UI top bar).
 *
 * GA4 should be wired only inside GTM (GA4 Configuration tag with your Measurement ID).
 * Do not add a second gtag.js snippet in index.html for the same property.
 */
export const GTM_ID: string = 'GTM-MCTNNR77'

/** Skip loading the GTM snippet until a real container ID is set. */
export function isGtmContainerConfigured(): boolean {
  return Boolean(GTM_ID && GTM_ID !== 'GTM-XXXXXXX' && /^GTM-[A-Z0-9]+$/.test(GTM_ID))
}
